<template>
  <section>
    <Loader :visible="loading"></Loader>
    <div class="contact-container container mt-30">
      <div class="row">
        <div class="col-md-2 col-1"></div>
        <div class="col-md-8 col-10">
          <div align="center">
            <div class="message_circle">
              <i class="far fa-envelope icon_message"></i>
            </div>
            <h2 class="page-title">{{$t("contact.title")}}</h2>
          </div>
          <div class="row mt-5">
            <div class="col-md-12">
              <form @submit.prevent="send" method="post">
                <div class="form-group">
                  <input type="text" v-model="contact.name" required class="form-control input-form" :placeholder="$t('contact.name')" />
                </div>
                <div class="form-group">
                  <input type="email" v-model="contact.email" required class="form-control input-form" :placeholder="$t('contact.email')" />
                </div>
                <div class="form-group mt-4">
                  <select v-model="contact.interests" required class="form-select input-search">
                    <option v-for="(interest, idx) in interests" :key="idx" :value="interest.value">
                      {{ interest.text }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <input type="text" v-model="contact.subject" required class="form-control input-form" :placeholder="$t('contact.subject')" />
                </div>
                <div class="form-group">
                  <textarea class="form-control textarea-form"
                    required
                    :placeholder="$t('contact.message')"
                    rows="4"
                    v-model="contact.message">
                   </textarea>
                </div>
                <div class="row" style="margin-top: 30px">
                  <div class="col-md-12">
                    <button type="submit" class="primary-btn-light">
                      {{$t("contact.send")}}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-1">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Loader from "../../components/Loader"
import Contact from "../../models/Contact"
export default {
  name: "ContactLanding",
  components:{
    Loader
  },
  data() {
    return{
      interests: [
        {value: null, text: 'Selecciona una opción'},
        {value: 'Fotografos', text: 'Fotografos'},
        {value: 'Escuelas', text: 'Escuelas'},
        {value: 'Eventos', text: 'Eventos'},
        {value: 'Eventos Deportivos', text: 'Eventos Deportivos'},
        {value: 'Otro', text: 'Otro'},
      ],
      loading: false,
      contact: new Contact()
    }
  },
  methods:{
    async send() {
      this.loading = true
      const response = await this.contact.sendEmail();

      if(response) {
        this.$alertify.success(this.$t("contact.success"))
        this.contact = new Contact()
      } else {
        this.$alertify.error(this.$t("contact.error"))
      }
      this.loading = false
    },
  }
}
</script>

<style lang="scss">
  .contact-container {
    margin-bottom: 80px;
  }
</style>
